












import { ILocale } from "@/@types/locale";
import { Component, Prop, Vue } from "vue-property-decorator";

interface IHL {
  _id: string;
  name: ILocale;
}

@Component({})
export default class HorizontalList extends Vue {
  @Prop({ type: Array, default: () => [] }) list!: Array<IHL>;
}
